// @flow

import { connect } from "react-redux";
import React, { useCallback } from "react";

import Date from "./index";
import { setUserAnalytics } from "src/actions/userAnalytics";

import type { AppState, UserAnalyticsFilter } from "src/types";

type Props = {
  filter: UserAnalyticsFilter,
  _setUserAnalytics: Function
};

const Created = ({ filter, _setUserAnalytics }: Props) => {
  const handleChange = useCallback(
    (createdAt: ?string) => {
      _setUserAnalytics({
        query: {
          ...filter,
          createdAt
        }
      });
    },
    [filter, _setUserAnalytics]
  );

  const { createdAt } = filter;

  return <Date name="created" value={createdAt} handleChange={handleChange} />;
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  filter: app.userAnalytics.filter
});

export default connect(mapStateToProps, {
  _setUserAnalytics: setUserAnalytics
})(Created);
